import styled from 'styled-components';
import { StyledPlatformIndicatorProps } from './PlatformIndicator.types';

export const StyledPlatformIndicator = styled.div<StyledPlatformIndicatorProps>`
  display: inline-flex;
  align-items: center;

  & + & {
    margin-left: 15px;
  }
  .platform-indicator__name {
    margin-left: 3px;
  }

  ${(props) => props.customStyle}
`;
